import React from 'react';
import Navbar from '../shared/Navbar';
import CourseDetails from './CourseDetails';

function CoursePage() {
  return (
    <div className="app">
      <Navbar />
      <main className="app-main">
        <div className="content-container">
          <CourseDetails />
        </div>
      </main>
    </div>
  );
}

export default CoursePage;
